export const GET_PAY_AT_HOTEL_ACTION = "GET_PAY_AT_HOTEL_ACTION";
export const GET_PAY_AT_HOTEL_SUCCESS = "GET_PAY_AT_HOTEL_SUCCESS";

export const GET_PROFILE_TYPE_ACTION = "GET_PROFILE_TYPE_ACTION";
export const GET_PROFILE_TYPE_SUCCESS = "GET_PROFILE_TYPE_SUCCESS";

export const PAY_AT_HOTEL_UPDATE_ACTION = "PAY_AT_HOTEL_UPDATE_ACTION";
export const PAY_AT_HOTEL_UPDATE_SUCCESS = "PAY_AT_HOTEL_UPDATE_SUCCESS";

export const PAY_AT_HOTEL_FAIL = "PAY_AT_HOTEL_FAIL"